import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  skeleton: {
    '& span': {
      '& span': {
        paddingTop: 'calc(100% - 16px)',
        lineHeight: 1.1
      }
    }
  }
})

export default useStyles
